import React, { FC } from 'react';
// mui components
import {
  Dialog,
  DialogActions,
  DialogContent,
  // DialogTitle,
  // IconButton,
  Button,
  styled,
  Theme,
} from '@mui/material';
// types
import { SxProps } from '@mui/system';

const StyledDialog = styled(({ withoutPadding, ...props }: any) => <Dialog {...props} />)(
  ({ width, maxWidth, withoutPadding }) => ({
    '& .MuiDialogContent-root': {
      margin: withoutPadding ? 0 : '10px 0 0',
      padding: 0,
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },
    '& .MuiDialog-paper': {
      width: width || '480px',
      maxWidth: maxWidth || '480px',
      maxHeight: '86vh',
      padding: withoutPadding ? 0 : '30px 40px 15px 40px',
      borderRadius: '12px',
      overflow: 'visible',
      backgroundColor: '#fff',
    },
  })
);
const StyledButton = styled(Button)({
  height: '48px',
  width: '126px',
  textTransform: 'unset',
  boxShadow: 'none',
});
interface IProps {
  open: boolean;
  withCloseButton?: boolean;
  withoutPadding?: boolean;
  withActions?: boolean;
  width?: string;
  maxWidth?: string;
  handleClose: () => void;
  contentSx?: SxProps<Theme>;
}
const DialogModal: FC<IProps> = ({
  open,
  withoutPadding,
  withActions,
  width,
  maxWidth,
  handleClose,
  children,
  contentSx,
}) => {
  return (
    <StyledDialog
      open={open}
      maxWidth={maxWidth}
      width={width}
      withoutPadding={withoutPadding}
      onClose={handleClose}
    >
      <DialogContent sx={contentSx}>{children}</DialogContent>
      {withActions && (
        <DialogActions>
          <StyledButton variant="contained" onClick={handleClose}>
            close
          </StyledButton>
        </DialogActions>
      )}
    </StyledDialog>
  );
};
export default DialogModal;
